import React from 'react';
import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import { InputCheckBox } from '@itandi/itandi-bb-ui';
import type { VendorCompany } from '~/models/VendorCompany';
import Styles from './VendorPartnerCandidateRow.module.scss';

type Props = DeepReadonly<{
  vendorCompany: VendorCompany;
  selectedIds: number[];
  handleChangeSelectedIds: (newSelectedIds: number[]) => void;
}>;

export const VendorPartnerCandidateRow: React.FC<Props> = ({
  vendorCompany,
  selectedIds,
  handleChangeSelectedIds
}: Props) => {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.checked) {
        handleChangeSelectedIds([...selectedIds, vendorCompany.id]);
      } else {
        handleChangeSelectedIds(
          selectedIds.filter((id) => id !== vendorCompany.id)
        );
      }
    },
    [handleChangeSelectedIds, selectedIds, vendorCompany.id]
  );
  return (
    <div className={Styles.Row}>
      <InputCheckBox
        checked={selectedIds.includes(vendorCompany.id)}
        label={vendorCompany.name}
        onChange={handleChange}
      />
    </div>
  );
};
